import React, { Component } from 'react';

import TeacherCard from './../TeacherCard';
import Choose from "../../pages/Choose";

class TeachersGridTest extends Component {
  state = {
    teachersToShow: [],
    loading: true
  };

  componentWillMount = () => {
    fetch('https://raw.githubusercontent.com/VahanSargsyan/dumy/master/dumyData.json', { method: 'GET'})
      .then(resp => resp.json())
      .then(resp => this.setState({
              loading: false,
              teachersToShow: resp
            })
  )};

  render() {
    let grid;
    if (this.state.loading) {
      grid = <p>Բեռնում․․․․․</p>
    } else {
      grid = this.state.teachersToShow.map(v => (
        <div>
          <TeacherCard key={v.name} setTeacher={this.props.setTeacher} teacher={v} isActive={true}/>
          <Choose teacher={v}></Choose>
        </div>
    ));
    }


    return (
      <div className="teachersGrid">
        {(grid.length) ? grid : <p className="massage text-center">
          Ձեր հարցմամբ ուսուցիչ չի գտնվել
        </p> }
      </div>
    )
  }
}

export default TeachersGridTest;